import { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faKey } from "@fortawesome/free-solid-svg-icons";
import logo from "../logo.jpg";
import "./logInStyles.css";

export default class LogInForm extends Component {
  constructor() {
    super();
    this.state = {
      pswd: "",
      userName: "",
      rememberMe: false, // New state for "Remember Me" checkbox
      inputsAreNotValid: false,
      errorMessages: [],
    };
  }
  componentDidMount() {
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    console.log(rememberedUsername);
    if (rememberedUsername) {
      this.setState({ userName: rememberedUsername, rememberMe: true });
    }
  }
  handleInputChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleCheckboxChange = (e) => {
    this.setState({ rememberMe: e.target.checked });
  };

  validateInputs = () => {
    const { userName, pswd } = this.state;
    const errors = [];

    // Validate username (must be a valid email)
    if (!userName || userName.trim() === "") {
      errors.push("اسم المستخدم مطلوب.");
    } else if (!this.validateEmail(userName)) {
      errors.push("يجب أن يكون اسم المستخدم بريدًا إلكترونيًا صالحًا.");
    }

    // Validate password
    if (!pswd || pswd.trim() === "") {
      errors.push("كلمة المرور مطلوبة.");
    } else if (pswd.length < 8) {
      errors.push("يجب أن تكون كلمة المرور على الأقل 8 أحرف.");
    }

    if (errors.length > 0) {
      this.setState({ inputsAreNotValid: true, errorMessages: errors });
      return false;
    }

    this.setState({ inputsAreNotValid: false, errorMessages: [] });
    return true;
  };

  validateEmail = (email) => {
    // Regular expression for validating an email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  handleLogIn = () => {
    if (this.validateInputs()) {
      const { pswd, userName, rememberMe } = this.state;
      // If inputs are valid, call the onLogIn prop
      this.props.onLogIn({ password: pswd, userName, rememberMe });
    }
  };

  render() {
    const { inputsAreNotValid, errorMessages, rememberMe, userName } =
      this.state;
    return (
      <>
        <Container fluid className="border border-2 rounded-2 m-1 shadow mt-3">
          <Row>
            <Col xs={12} className="text-center">
              {" "}
              <Image
                src={logo}
                rounded
                style={{ width: "150px", height: "150px" }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h5 className="text-center">إدارة تسيير المخزون و الصيانة</h5>
              {inputsAreNotValid && (
                <div
                  className="alert alert-danger p-1"
                  role="alert"
                  style={{ fontSize: "10px" }}
                >
                  <ul>
                    {errorMessages.map((err, idx) => (
                      <li key={"login-error" + idx}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}
              <hr />
              <h6>تسجيل الدخول الى حسابكم </h6>
              <div className="log-in-container " style={{ width: "100%" }}>
                <FontAwesomeIcon
                  icon={faUser}
                  size="2x"
                  color="rgb(3, 102, 119)"
                />
                <input
                  className="loginIput"
                  value={userName}
                  onChange={(e) =>
                    this.handleInputChange("userName", e.target.value)
                  }
                />
              </div>
              <div className="log-in-container " style={{ width: "100%" }}>
                <FontAwesomeIcon
                  icon={faKey}
                  size="2x"
                  color="rgb(3, 102, 119)"
                />
                <input
                  className="loginIput"
                  type="password"
                  onChange={(e) =>
                    this.handleInputChange("pswd", e.target.value)
                  }
                />
              </div>
              {/* "Remember Me" Checkbox */}
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={this.handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="rememberMe">
                  تذكرني
                </label>
              </div>
              <div className="d-grid gap-2 mb-3">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={this.handleLogIn}
                  style={{ height: "45px" }}
                >
                  {this.props.isLoading && (
                    <div
                      className="spinner-border text-primary mx-3"
                      role="status"
                      style={{ width: "15px", height: "15px" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                  تسجيل الدخول{" "}
                </button>
              </div>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              <div className="text-muted" style={{ fontSize: "10px" }}>
                © {new Date().getFullYear()} جميع الحقوق محفوظة كلية العلوم
                الاقتصادية التجارية و علوم التسيير جامعة غليزان
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
